<template>
  <div v-bind="$attrs">
    <div class="overflow-hidden -mb-[0.1em]">
      <div
        class="slide-up-animation"
        :class="{
          'translate-x-full': horizontal && !reversed,
          '-translate-x-full': horizontal && reversed,
          'translate-y-full': !horizontal && !reversed,
          '-translate-y-full': !horizontal && reversed,
          'transition-transform transform-none': inView,
        }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import inViewMixin from '../../mixins/in-view'

export default {
  name: 'SlideUpAnimation',
  mixins: [inViewMixin],
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
